// extracted by mini-css-extract-plugin
export default {"root":"styles_root__v6jtV","form_container":"styles_form_container__hIFHT","form_body":"styles_form_body__+25ud","hello_text":"styles_hello_text__nY1vj"};